import { FormattedMessage } from "react-intl";

const StandardSupport = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.standardSupport.content.body"
                    defaultMessage="2-hr response time for critical issues from Cloud support team."
                />
            </p>
        </div>
    );
};

export default StandardSupport;
